import { apiSahPricePlans } from '~constants/api';

import { get, post, put, remove } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'sah-price-plans';

const config = [
  { actionType: 'getAll', apiPath: apiSahPricePlans, method: get },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiSahPricePlans}/${params.id}`, method: get },
  { actionType: 'create', apiPath: apiSahPricePlans, method: post },
  { actionType: 'update', apiPath: (params: Params) => `${apiSahPricePlans}/${params.id}`, method: put },
  { actionType: 'deleteOne', apiPath: (params: Params) => `${apiSahPricePlans}/${params.id}`, method: remove },
];

export const { getAll, getOne, create, update, deleteOne } = createThunks(typePrefix, config);
